import cn from 'classnames'
import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { Flex } from 'core-components/library/flex'
import { Tooltip } from 'core-components/library/tooltip'
import { ContactTicketIcon } from 'partner360/common/hpContacts/contactTicketIcon/ContactTicketIcon'
import { TRANSLATION_KEYS } from 'partner360/widgets/ramManagerAssignment/translations'

interface IContactInfoProps {
  contact: IFormJBPHPContactChangeRequest
}

export const HPContactInfo = ({ contact }: IContactInfoProps) => {
  return (
    <Flex>
      <ContactTicketIcon item={contact} />
      <Flex>
        <span>
          <Tooltip tipContent={() => <div>{contact.Email}</div>}>
            {contact.FirstName} {contact.LastName}
          </Tooltip>
        </span>
        <RenderWhen condition={Boolean(contact.LeadPBM)}>
          <Tooltip tipContent={() => <Translation text={TRANSLATION_KEYS.columns.leadPbm} />}>
            <i className={cn('kbase kbase-lvl-users')} />
          </Tooltip>
        </RenderWhen>
      </Flex>
    </Flex>
  )
}
